export default __webpack_public_path__ + "images/csv-64.png";